// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_e2-0";
export var actionModalContentContainer = "_e2-1";
export var createTagButton = "_e2-2";
export var footerContainer = "_e2-7";
export var fullWidthDivider = "_e2-3";
export var hasCreateTagButton = "_e2-4";
export var noCreateTagButton = "_e2-5";
export var tagsContainer = "_e2-6";
export var tagsModalContentContainer = "_e2-8";